module.exports = __webpack_public_path__ + "img/close_btn.db1dae5e.svg";